// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J7Sg","fullView":"styles_fullView__2hqJc"};